


<app-loader [show]="skeleton"></app-loader>
<div [class.d-none]="skeleton">
  <div class="row">
  <div class="col-md-3 bg-white rounded shadow">
    <div class="pl-3 pr-5">
      <app-navbar [step]="3">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
    <app-breadcrumb [title]="'Photo & Sign'"></app-breadcrumb>
  <form [formGroup]="profileThumbForm" (ngSubmit)="save()">
    <input type="hidden" formControlName="profileId">
    <input type="hidden" formControlName="photoId">
    <input type="hidden" formControlName="signId">

    <div class="border rounded p-3 mb-3">
      <div class="row">
        <div class="col-lg-6">
          <div class="text-center">
            <img alt="no-image" [src]="pic" class="img-fluid border mt-2" width="128" height="128">
            <div class="mt-2">
              <button class="btn btn-primary fileinput-zone position-relative">
                <i-bs name="upload" width="1em" height="1em"></i-bs> Upload Photo
                <input type="file" #photo (change)="handleFileInput($event.target.files);OnSubmit(photo, 'photo')"
                  accept="image/x-png,image/gif,image/jpeg">
              </button>
            </div>
            <small>For best results, use an image at least 128px by 128px in .jpg format</small>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="text-center">
            <img alt="no-image" [src]="sin" class="img-fluid border mt-2" width="320" height="110">
            <div class="mt-2">
              <button class="btn btn-primary fileinput-zone position-relative">
                <i-bs name="upload" width="1em" height="1em"></i-bs> Upload Sign
                <input type="file" #sign (change)="handleFileInput($event.target.files);OnSubmit(sign, 'sign')"
                  accept="image/x-png,image/gif,image/jpeg">
              </button>
            </div>
            <small>For best results, use an image at least 320px by 110px in .jpg format</small>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="d-flex justify-content-center mb-3">
        <a [routerLink]="['/employee/profile/contact']" class="btn btn-primary rounded-0">PREVIOUS</a>
      </div>
      <button class="btn btn-primary rounded-0 ml-auto mr-2 mb-3" [disabled]="!profileThumbForm.valid || loading"
        type="submit">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
        NEXT
      </button>
    </div>
  </form>
</div>
</div>
</div>
